import React from "react";
import { isMobile, isTablet } from "react-device-detect";

import { useRouter } from "next/router";

import { Input } from "antd";
import { debounce } from "lodash";

import { useApplicationContext } from "contexts/app";

const TableSearch = ({ searchKey = "search", ...rest }: any) => {
  const router = useRouter();
  const { search } = router.query;

  const { collapsedSidebar } = useApplicationContext();

  const handleOnChange = debounce((val: string) => {
    router.push(
      {
        pathname: router?.pathname,
        query: {
          ...router?.query,
          [searchKey]: val,
        },
      },
      undefined,
      { shallow: true }
    );
  }, 500);

  return (
    <Input.Search
      {...rest}
      defaultValue={search?.toString()}
      size={"middle"}
      onChange={(e) => {
        handleOnChange(e.target.value);
      }}
      allowClear
      style={{ width: !collapsedSidebar && (isMobile || isTablet) ? 110 : 180 }}
    />
  );
};

export default TableSearch;
